const sectionPaths = {
	SECTION: "",
	SEARCH_SECTION: "search",
	SECTION_ID: (sectionId) => sectionId,    
};

export default sectionPaths;